import { stringToQuery } from 'utils'
import ConfigService from './ConfigService'
import BaseService from './BaseService'

export default new (class KwkService extends BaseService {
  constructor() {
    super({
      baseURL: () => ConfigService.get('api.kwk')
    })

    const { kdnr } = stringToQuery(document.location.hash.slice(1))
    this.customerNumber = /^\d+$/.test(kdnr) ? kdnr : ''
  }

  setCustomerNumber(customerNumber) {
    this.customerNumber = customerNumber
  }

  createPromotionLink({ channel, productArea }) {
    return this.post('/frontend/kwk/social-share-data', {
      channel,
      productArea,
      customerNumber: this.customerNumber
    }).then(({ data }) => data.url)
  }
})()
